
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire49d7"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire49d7"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("i05Hf", function(module, exports) {

$parcel$export(module.exports, "default", () => $7d6cd15b3c948fc7$export$2e2bcd8739ae039);
const $7d6cd15b3c948fc7$var$emptyAmplitudeSessionReplay = {
    init: ()=>Promise.resolve(),
    stop: ()=>Promise.resolve()
};
var $7d6cd15b3c948fc7$export$2e2bcd8739ae039 = $7d6cd15b3c948fc7$var$emptyAmplitudeSessionReplay;

});


//# sourceMappingURL=empty.22dffc54.js.map
